import { QueryResult, useQuery } from '@apollo/client';
import { GET_TIMESHEET_REASONS } from '@bechtel/client-gql';
import { TimesheetReason } from '@bechtel/types';

export function useTimeSheetReason(fetchFromNetwork?: boolean): QueryResult<{ timesheetReason: TimesheetReason[] }> {
  const response = useQuery<{ timesheetReason: TimesheetReason[] }, Record<string, any>>(
    GET_TIMESHEET_REASONS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
